function initAccessibleFilter({
  container = '.filter-contain',
  itemSelector = '.prod-card',
  filters = [],
  summaryTarget = '#a11y-filter-status',
  clearOnToggle = false,
  toggleButton = '.filter-toggle',
  filterPanel = '.press-on-filter',
  syncURL = true
}) {
  const $container = $(container);
  const $items = $(itemSelector);
  const $summary = $(summaryTarget);
  const $toggle = $container.find(toggleButton);
  const $panel = $container.find(filterPanel);

  if ($toggle.length && $panel.length) {
    $toggle.attr('role', 'button').attr('aria-expanded', 'false').attr('tabindex', 0);

    $toggle.on('click keypress', function (e) {
      if (e.type === 'click' || e.key === 'Enter' || e.key === ' ') {
        const expanded = $(this).attr('aria-expanded') === 'true';
        $(this).attr('aria-expanded', !expanded);
        $panel.toggle();
      }
    });
  }

  filters.forEach(f => {
    $container.on('change', f.selector, function () {
      applyFilterLogic();
      if (syncURL) updateURL();
    });
  });

  // Use an explicit urlKey if given, otherwise fall back to dataAttr
  function getURLKey(f) {
    return f.urlKey || f.dataAttr;
  }

  function updateURL() {
    const params = new URLSearchParams(window.location.search);

    filters.forEach(f => {
      const key = getURLKey(f);
      const $checked = $container.find(`${f.selector}:checked`);

      if ($checked.length === 0) {
        params.delete(key);
      } else {
        const values = $checked.map(function () {
          return $(this).data('id');
        }).get();
        params.set(key, values.join(','));
      }
    });

    const qs = params.toString();
    const newURL = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
    // replaceState avoids polluting history on every checkbox click,
    // but the URL still persists for reload, share, and back-to-page.
    window.history.replaceState({ filters: true }, '', newURL);
  }

  function applyFiltersFromURL() {
    const params = new URLSearchParams(window.location.search);

    filters.forEach(f => {
      const key = getURLKey(f);
      if (!params.has(key)) return;

      const ids = (params.get(key) || '').split(',').filter(Boolean);

      $container.find(f.selector).each(function () {
        const id = String($(this).data('id'));
        $(this).prop('checked', ids.includes(id));
      });
    });
  }

  function applyFilterLogic() {
    $items.show();
    filters.forEach(f => {
      const $checked = $container.find(`${f.selector}:checked`);
      if ($checked.length === 0) return;

      const selected = $checked.map(function () {
        return $(this).data('id');
      }).get();

      $items.filter(function () {
        const val = $(this).data(f.dataAttr);
        return !selected.includes(val);
      }).hide();
    });

    announceFilters();
  }

  function announceFilters() {
    const visibleCount = $items.filter(':visible').length;

    const descriptions = filters.map(f => {
      const $checked = $container.find(`${f.selector}:checked`);
      if ($checked.length === 0) return null;
      const labels = $checked.map(function () {
        return $(this).siblings('label').text().trim();
      }).get();
      return `${f.label}: ${labels.join(', ')}`;
    }).filter(Boolean);

    const summary = descriptions.length
      ? `Filters applied: ${descriptions.join('. ')}.`
      : 'No filters applied.';

    const result = visibleCount === 0
      ? 'No products match your filter selections.'
      : `${visibleCount} product${visibleCount > 1 ? 's' : ''} shown.`;

    $summary.text('');
    setTimeout(() => $summary.text(`${summary} ${result}`), 20);
  }

  // Re-sync if user hits back/forward
  if (syncURL) {
    $(window).on('popstate', function () {
      applyFiltersFromURL();
      applyFilterLogic();
    });
  }

  // Init: read URL → check boxes → filter
  if (syncURL) applyFiltersFromURL();
  applyFilterLogic();
}